import { render, staticRenderFns } from "./CabinetSettingsCard.vue?vue&type=template&id=63773aa6&scoped=true&"
import script from "./CabinetSettingsCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CabinetSettingsCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CabinetSettingsCard.vue?vue&type=style&index=0&id=63773aa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63773aa6",
  null
  
)

export default component.exports